import script from "./CsUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./CsUpload.vue?vue&type=script&setup=true&lang=js"

import "./CsUpload.vue?vue&type=style&index=0&id=4d104ed8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d104ed8"]])

export default __exports__